<template>
  <div>
    <button @click="add">{{ count }}</button>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
    }
  },
  data () {
    return {
      count: this.value
    }
  },
  methods: {
    add () {
      this.count++
      this.$emit('input', this.count)
    }
  },
}
</script>